module.exports = __webpack_public_path__ + "img/list.06bc4a23.svg";